// extracted by mini-css-extract-plugin
export var banner = "_r6-0";
export var settingRow = "_r6-2";
export var titleIcon = "_r6-1";